import posthog from "posthog-js";

type PostHogProperties = Record<string, string | number | boolean | null | undefined>;

export function capturePostHogEvent(event: string, properties?: PostHogProperties) {
  if (typeof window === "undefined") {
    return;
  }

  posthog.capture(event, properties);
}

export function resetPostHog() {
  if (typeof window === "undefined") {
    return;
  }

  posthog.reset();
}
